import { __assign, __rest } from "tslib";
import React from 'react';
import { twMerge } from 'tailwind-merge';
var GridWrapper = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("div", __assign({}, rest, { className: twMerge('grid grid-cols-[0_1fr] grid-rows-[98px_1fr] min-h-screen xl:grid-cols-[auto_1fr]', className) }), children));
};
export default GridWrapper;
